import type {PickupStation} from '@yandex-delivery/api/repo/tariffs'
import type {Point} from '@yandex-delivery/core/types'
import React from 'react'

import {TariffsMap} from '../../../../components/TariffsMap'
import styleClasses from './classes.module.css'
import {marker, pickupStationsToMapPoints} from './utils'

type Props = {
  points?: PickupStation[]
  polygon?: Point[]
  onFullSize?: VoidFunction
}

export function Map({points, polygon, onFullSize}: Props) {
  return (
    <div className={styleClasses.wrapper}>
      <TariffsMap
        marker={marker}
        onFullSize={onFullSize}
        points={pickupStationsToMapPoints(points)}
        polygon={polygon}
        isStatic
      />

      {/* Не даёт статичной карте перехватывать события */}
      <div className={styleClasses.overlay} />
    </div>
  )
}
